export default __webpack_public_path__ + "static/media/section3Img.82bcc85c.jpg";